import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsApplianceDetailsAdditionalAppliancesBenefitsPanel } from './cms-appliance-details-additional-appliances-benefits-panel.interface';

export interface CmsApplianceDetailsAdditionalAppliancesPage
  extends CmsRegistrationRoot {
  applianceDetailsAdditionalAppliancesBenefitsPanel: CmsApplianceDetailsAdditionalAppliancesBenefitsPanel;
}
